module.exports = __webpack_public_path__ + "static/media/plus.526b38d3.svg";